import { ItemType } from '@vista-digital/ocapi-types/v1';
import { getInProgressItem } from './get-in-progress-item';
export const getInProgressItemModifierGroup = (inProgressItemModifierGroupId) => {
    const inProgressItem = getInProgressItem();
    if ((inProgressItem === null || inProgressItem === void 0 ? void 0 : inProgressItem.type) !== ItemType.Normal) {
        throw new Error('Cannot get modifier group without an in-progress normal item.');
    }
    const modifierGroup = inProgressItem.modifierGroups.find(mg => mg.itemModifierGroupId === inProgressItemModifierGroupId);
    if (!modifierGroup) {
        throw new Error(`Could not find modifier group ${inProgressItemModifierGroupId} on in-progress item ${inProgressItem.id}`);
    }
    return modifierGroup;
};
